import { instance } from 'api/core';
import { CallbackObject } from 'api/core/get-page-function';

export const syncProducts = async (serverId: string, callback: CallbackObject<void>) => {
  try {
    await instance.post(`/asrs/servers/${serverId}/sync-products`);
    callback.success();
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
